module.exports = __webpack_public_path__ + "static/Rectify-ad3a0e59aeefbf67bafc938dcf14d6be.jpg";